module.exports = __webpack_public_path__ + "img/icon-group7.557718ba.png";